"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reduxForm = require("redux-form");

var _index = require("../../../fields/index");

var _HeightSelectFields = _interopRequireDefault(require("./HeightSelectFields"));

var _index2 = require("../../../types/index");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _index2.FieldElementDefinition;
});

var FieldProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FieldProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("parentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("height", _flowRuntime["default"].ref(FieldElementDefinition))));

var RenderProps = _flowRuntime["default"].type("RenderProps", _flowRuntime["default"].intersection(Props, _flowRuntime["default"].ref(FieldProps)));

var HeightSelect = function HeightSelect(_arg) {
  var parentKey = _arg.parentKey,
      height = _arg.height,
      meta = _arg.meta,
      input = _arg.input,
      custom = _arg.custom;
  return /*#__PURE__*/React.createElement(_index.FormComponentWrapper, {
    component: height,
    parentKey: parentKey,
    renderComponent: function renderComponent(_ref) {
      var componentKey = _ref.componentKey;
      return /*#__PURE__*/React.createElement(_HeightSelectFields["default"], {
        componentKey: componentKey,
        height: height,
        meta: meta,
        input: input,
        custom: custom
      });
    }
  });
};

var _default = HeightSelect;
exports["default"] = _default;